// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2quG2","right":"Footer_right__1lc8S","buttons":"Footer_buttons__1R9yP"};